var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"homeView"}},[_c('topNav'),_c('ruleListView',{ref:"ruleListView",on:{"ruleParentReceive":_vm.ruleParentReceiveFN}}),_c('floatRightView'),_c('router-view',{key:_vm.$route.fullPath}),_c('footertView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }